import React from 'react';
import ActiveText from '../modals/ActiveText';
import { TRANSLATIONS } from '../../../translations';
import {
  TypographyVariants,
  TypographyWeights,
} from '../../ui-components/Typography/Typography';
import TextToCanvas from './TextToCanvas';

const ShowLegalInfo = ({ company, vat, taxId, tourOperator }) => {
  return (
    <ActiveText
      clickable={TRANSLATIONS.LEGAL_INFO_ACTIVITY}
      weight={TypographyWeights['semi-bold']}
      variant={TypographyVariants.p3}
      content={<TextToCanvas company={company} vatNumber={vat} taxId={taxId} tourOperator={tourOperator} />}
      title={TRANSLATIONS.LEGAL_INFO_ACTIVITY}
      modalCustomWidth={740}
      dataLayerEvent={`clickOnLegalInfo`}
    />
  );
};

ShowLegalInfo.propTypes = {};

ShowLegalInfo.defaultProps = {};

ShowLegalInfo.sanitizeProps = (props) => {
  const sanitized = { ...props };

  // Helper function to parse JSON-encoded values
  const parseEncryptedValue = (value) => {
    // Handle undefined or empty string
    if (!value || value === '') {
      return null;
    }

    try {
      const parsed = JSON.parse(value);
      // If parsed result is null, return null
      // Otherwise return the parsed string
      return parsed;
    } catch (e) {
      // If it's not valid JSON, return as-is
      return value;
    }
  };

  // Parse JSON-encoded encrypted values
  sanitized.company = parseEncryptedValue(props.company);
  sanitized.vat = parseEncryptedValue(props.vat);
  sanitized.taxId = parseEncryptedValue(props.taxId);
  sanitized.tourOperator = parseEncryptedValue(props.tourOperator);

  return sanitized;
};

export { ShowLegalInfo };
